import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["autoSelect", "buttonUse", "buttonRowRenderer", "inputRef", "onChange", "onCopy", "textAreaProps", "tooltipPlacement", "use", "value"];
import { Controllable } from '../Controllable';
import { DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE } from '../../constants';
import { CopyButton } from '../CopyButton/CopyButton';
import { ExpandingTextArea } from '../ExpandingTextArea/ExpandingTextArea';
import { TextArea } from '../TextArea/TextArea';
import ShareInput from '../ShareInput/ShareInput';
import { memo, useState } from 'react';
import { View } from '../../../components/View/View';
import { filterProps } from '../../../utils/filterProps';
import { CopyTextAreaContextProvider } from './CopyTextAreaContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DefaultButtonRow = ({
  onClick,
  tooltipPlacement,
  use,
  value
}) => /*#__PURE__*/_jsx(View, {
  marginBlock: "300",
  children: /*#__PURE__*/_jsx(CopyButton, {
    onClick: onClick,
    tooltipPlacement: tooltipPlacement,
    use: use,
    value: value
  })
});
const getResizeOffset = evt => {
  const rect = evt.target.getBoundingClientRect();
  return {
    bottom: rect.bottom - evt.clientY,
    right: rect.right - evt.clientX
  };
};
export const CopyTextAreaComponent = _ref => {
  let {
      autoSelect = true,
      buttonUse = 'tertiary',
      buttonRowRenderer: ButtonRowRenderer = DefaultButtonRow,
      inputRef,
      onChange,
      onCopy,
      textAreaProps = {
        resize: 'vertical',
        error: false,
        styled: true
      },
      tooltipPlacement = 'right',
      use = 'default',
      value
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [isResizing, setIsResizing] = useState(false);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const handleCopyClick = evt => {
    if (!inputRef) return;
    if (inputRef.current) inputRef.current.select();
    if (onCopy) onCopy(evt);
  };
  const handleTextAreaMouseMove = evt => {
    const resizeHandleLength = 18;
    const {
      bottom,
      right
    } = getResizeOffset(evt);
    const isResizingValue = bottom < resizeHandleLength && right < resizeHandleLength;
    setIsResizing(isResizingValue);
  };
  const handleTextAreaMouseDown = evt => {
    if (!inputRef) return;
    if (autoSelect && !isResizing) {
      evt.preventDefault();
      if (inputRef.current) inputRef.current.select();
    }
  };
  const isCode = use === 'code';
  const TextAreaComponent = isCode ? TextArea : ExpandingTextArea;
  return /*#__PURE__*/_jsx(CopyTextAreaContextProvider, {
    value: {
      isBgTransparent: true,
      isCode
    },
    [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: 'CopyTextArea',
    children: /*#__PURE__*/_jsxs(View, Object.assign({}, domProps, tokenProps, {
      children: [/*#__PURE__*/_jsx(TextAreaComponent, Object.assign({}, textAreaProps, {
        inputRef: inputRef,
        onChange: onChange,
        onMouseMove: autoSelect && textAreaProps.resize !== false ? handleTextAreaMouseMove : null,
        onMouseDown: handleTextAreaMouseDown,
        readOnly: textAreaProps.readOnly,
        resize: isCode ? false : textAreaProps.resize,
        value: value,
        isCode: isCode
      })), /*#__PURE__*/_jsx(ButtonRowRenderer, {
        onClick: handleCopyClick,
        tooltipPlacement: tooltipPlacement,
        use: buttonUse,
        value: value
      })]
    }))
  });
};
export const CopyTextArea = ShareInput(Controllable( /*#__PURE__*/memo(CopyTextAreaComponent)));
CopyTextArea.displayName = 'CopyTextArea';